import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import classnames from 'classnames/bind';
import style from './input.module.scss';
import { useCreateCustomQuestion } from '@repository/interviewPractices/pooledQuestions/usePooledQuestions';
import { useInterview } from '@components/pass/interview/start/context/interviewContext';

import Colors from '@domain/constant/colors';
import Icon from '@components/common/assets';

const cx = classnames.bind(style);

interface InterviewPracticeQuestionSelectMyselfInputProps {
  refetchQuestionList: any;
}

const InterviewPracticeQuestionSelectMyselfInput: FC<InterviewPracticeQuestionSelectMyselfInputProps> = ({
  refetchQuestionList,
}) => {
  const { policies } = useInterview();
  const { mutateAsync: createMyselfQuestion } = useCreateCustomQuestion(() => {
    refetchQuestionList();
  });
  const maxLengthQuestionText = policies.maxLengthQuestionText;
  const [questionText, setQuestionText] = useState('');
  const domRef = useRef<HTMLTextAreaElement>(null);

  // onInput과 onChange는 거의 동일합니다.
  // React, for some reason, attaches listeners for `Component.onChange` to the DOM `element.oninput` event.
  // https://stackoverflow.com/questions/38256332/in-react-whats-the-difference-between-onchange-and-oninput

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.currentTarget;
    const newValue = value.replace(/\n/gm, '');
    if (newValue.length <= maxLengthQuestionText) {
      setQuestionText(newValue);
    }

    // 유효성 처리(\n 제거 및 length 제한)된 값이 textarea로 적용되기 전에 textareaResizer가 실행되는 것을 방지하기 위함
    requestAnimationFrame(() => textareaResizer());
  };

  const handleAddClick = async () => {
    await createMyselfQuestion(questionText);
    setQuestionText('');
  };

  const handleEnterKeyPress = async (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && event.currentTarget.value !== '') {
      await handleAddClick();
    }
  };

  // https://zetawiki.com/wiki/HTML_textarea_%EC%9E%90%EB%8F%99_%EB%86%92%EC%9D%B4_%EC%A1%B0%EC%A0%88 참조
  const textareaResizer = () => {
    const { current } = domRef;
    if (!current) {
      return;
    }
    current.style.height = '1px';
    current.style.height = current.scrollHeight + 2 + 'px'; // border 2px 추가
  };

  useEffect(() => {
    textareaResizer();
  }, []);

  return (
    <div className={cx('inputWrap')}>
      <span className={cx('question')}>Q</span>
      <textarea
        ref={domRef}
        className={cx('inputAdd')}
        value={questionText}
        placeholder={'질문을 작성해 주세요.'}
        onInput={handleInputChange}
        onKeyPress={handleEnterKeyPress}
        maxLength={maxLengthQuestionText}
      />
      <button className={cx('btnAdd', { btnActive: questionText.length > 0 })} onClick={handleAddClick}>
        <Icon
          name="addLight"
          width={24}
          height={24}
          fill={questionText.length > 0 ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
        />
        추가하기
      </button>
    </div>
  );
};

export default InterviewPracticeQuestionSelectMyselfInput;
